var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{attrs:{"name":"list","tag":"div","id":"toast-group"}})
}
var staticRenderFns = []

export { render, staticRenderFns }